import { useContext } from 'react';
import StyledSelect, { type StyledSelectProps } from './StyledSelect';
import { MenuItem } from '@mui/material';
import showRowNameOrPlaceholder from './showRowNameOrPlaceholder';
import ChallengePortfolioContext from '../../../../../../../ChallengePortfolioContext';
import sortByPosition from '@/lib/utils/sorting/sortByPosition';

type RowSelectProps = Omit<
  StyledSelectProps,
  'variant' | 'value' | 'renderValue' | 'displayEmpty' | 'children'
> & {
  value: number | null;
};

const RowSelect = ({ value, ...props }: RowSelectProps) => {
  const [challengePortfolio] = useContext(ChallengePortfolioContext);

  return (
    <StyledSelect
      variant="standard"
      value={value ?? ''}
      renderValue={showRowNameOrPlaceholder(challengePortfolio)}
      displayEmpty
      {...props}
    >
      {Object.values(challengePortfolio.rows)
        .sort(sortByPosition)
        .reverse()
        .map(row => (
          <MenuItem value={row.id} key={row.id}>
            {row.name}
          </MenuItem>
        ))}
    </StyledSelect>
  );
};

export default RowSelect;
